export default __webpack_public_path__ + "static/media/sphero-meter.2cefd906.jpg";